import { connect } from "../../utils/reduxUtils"
import Component from "./ResetPassword"
import * as AuthSelectors from "../../modules/auth/selectors"
import { Actions } from "../../pages/actions"
import { Actions as AuthActions } from '../../modules/auth/actions'

const mapDispatchToProps = {
    onSubmit: Actions.RESET_PASSWORD_FORM_SUBMITTED,
    onMount: Actions.RESET_PASSWORD_PAGE_MOUNTED
};

const mapStateToProps = state => {
    return {
        loading: AuthSelectors.isLoading(state),
        error: AuthSelectors.error(state),
        submitSuccess: AuthSelectors.submitSuccess(state),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Component);